import {Col, Row} from 'antd';
import {useIntl} from 'react-intl';
import {Input} from 'formik-antd';
import FormItem from '../../../../../../shared/components/form-item';
import {
  getLocaleValue,
  handleChangeLocales,
} from 'src/shared/functions/change-locales';
import {useFormikContext} from 'formik';

interface IProductTagInfoStandardProps {
  code?: string;
}

const {TextArea} = Input;

const ProductTagInfoStandard = (props: IProductTagInfoStandardProps) => {
  const {code} = props;

  const {messages} = useIntl();

  const {setFieldValue, values} = useFormikContext<any>();

  return (
    <>
      <Row gutter={[0, 20]}>
        <Col span={24}>
          <FormItem
            name='name'
            label={messages['productTags.create.name'].toString()}
            titleTooltip={messages[
              'tooltip.productTags.create.name'
            ].toString()}
            isTooltip
            fieldCommponent={
              <Input
                name='name'
                value={getLocaleValue(values?.locales, code, 'name')}
                onChange={(value) =>
                  handleChangeLocales(
                    values?.locales,
                    setFieldValue,
                    `locales`,
                    code,
                    'name',
                    value.target.value,
                  )
                }
              />
            }
          />
        </Col>

        <Col span={24}>
          <FormItem
            name='description'
            label={messages['productTags.create.description'].toString()}
            titleTooltip={messages[
              'tooltip.productTags.create.description'
            ].toString()}
            isTooltip
            fieldCommponent={<TextArea name='description' />}
          />
        </Col>
      </Row>
    </>
  );
};

export default ProductTagInfoStandard;
